// extracted by mini-css-extract-plugin
export default {"skipLink":"Layout_skipLink__PQqwN","main":"Layout_main__T84kS"};